import { useBulkDiscardRun } from "shared/Run/useDiscardRun";
import useCanDiscardStackRun from "shared/Stack/access/useCanDiscardStackRun";

import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { StackBulkActions } from "../types";
import { StackActionItemForBulkActions } from "./types";

const useDiscardStackRunBulkAction = (): StackActionItemForBulkActions => {
  const [runDiscard] = useBulkDiscardRun();

  const canDiscardStackRun = useCanDiscardStackRun();

  return {
    key: StackBulkActions.Discard,
    title: BULK_ACTION_NAMES[StackBulkActions.Discard],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.Discard],
    condition: (stack) => canDiscardStackRun(stack),
    mutation: (stack) => runDiscard({ stack: stack.id, note: null, run: null }),
  };
};

export default useDiscardStackRunBulkAction;
